(() => {
  if(customElements.get('trt-welding-video'))return;
  customElements.define('trt-welding-video',class extends HTMLElement{
    connectedCallback(){
      if(this.motion)return;
      const video=this.querySelector('video');
      if(!video)return;
      this.video=video;
      this.motion=window.matchMedia('(prefers-reduced-motion: reduce)');
      video.muted=true;
      video.defaultMuted=true;
      this.play=()=>{const result=video.play();if(result)result.catch(()=>{});};
      this.sync=()=>{video.autoplay=!this.motion.matches;if(this.motion.matches)video.pause();else this.play();};
      this.ready=()=>{if(!this.motion.matches)this.play();};
      this.motion.addEventListener('change',this.sync);
      video.addEventListener('canplay',this.ready,{once:true});
      this.sync();
    }
    disconnectedCallback(){
      if(!this.motion)return;
      this.motion.removeEventListener('change',this.sync);
      this.video.removeEventListener('canplay',this.ready);
      this.video.pause();
      this.motion=null;
    }
  });
})();
